import Dialog from "@mui/material/Dialog";
import Alert from '@mui/material/Alert';
import { Typography } from "@mui/material";

export default function Modalcondicionnull(props) {

    const handleClose = () => {
        props.open(false)
    };

    return (
        <Dialog open={props.open} maxWidth="lg">
                <Alert severity="warning" onClose={handleClose} >Atención
                    <Typography>La condición de venta no puede quedar vacia</Typography>
                </Alert>
        </Dialog>
    )
}
